import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "MedicalWebPage",
   "@id": "https://www.futurefamilyai.com/family-planning/carrier-screening/#webpage",
   "url": "https://www.futurefamilyai.com/family-planning/carrier-screening/",
   "name": "Carrier Screening Before Pregnancy | FutureFamilyAI",
   "description": "Learn what carrier screening shows, who should consider it, and how FutureFamilyAI's optional add-on helps couples prepare with a genetics professional.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Family Planning & Carrier Screening",
     "item": "https://www.futurefamilyai.com/family-planning/carrier-screening/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "What is carrier screening before pregnancy?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "It is a genetic test, usually on blood or saliva, that checks whether you carry variants for certain inherited conditions. Testing both partners shows whether a future child could be at higher risk."
     }
    },
    {
     "@type": "Question",
     "name": "Is carrier screening worth it?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Many families find it valuable because results arrive before decisions are made. ACOG recommends offering certain screening to everyone considering pregnancy. A genetics professional can help you decide."
     }
    },
    {
     "@type": "Question",
     "name": "When should you do carrier screening?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Ideally before pregnancy, so you have the most options. It can also be done during pregnancy."
     }
    },
    {
     "@type": "Question",
     "name": "Do both partners need carrier screening?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Often one partner tests first, and the other tests if a variant is found. Many couples test together to save time. FutureFamilyAI's couple summary requires results for both partners."
     }
    },
    {
     "@type": "Question",
     "name": "Does insurance cover carrier screening?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Coverage varies by plan and indication. Ask your insurer and request a written estimate. The FutureFamilyAI subscription does not include laboratory fees."
     }
    },
    {
     "@type": "Question",
     "name": "Is FutureFamilyAI's carrier screening a diagnosis?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. It is a screening summary reviewed by genetics professionals. Decisions should be made with a genetic counselor or physician."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function FamilyPlanningCarrierScreeningPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <span>Family Planning &amp; Carrier Screening</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                Carrier screening before pregnancy is a genetic test that shows
                whether you or your partner carry variants linked to certain
                inherited conditions.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Planning mothers &amp; couples</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      ACOG recommends offering carrier screening for cystic
                      fibrosis and spinal muscular atrophy to everyone who is
                      considering pregnancy or is pregnant. (ACOG Committee
                      Opinion No. 691, 2017)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      At-home saliva collection · Results explained with a
                      genetics professional · Patent-pending technology (U.S.
                      App. Nos. 19/407,993 et al.)
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">PILLAR GUIDE · FAMILY PLANNING</span>
            <h1>Carrier Screening Before Pregnancy — Plan With Confidence</h1>
            <p className="ffh-answer speakable-content">
              Carrier screening before pregnancy is a genetic test that shows
              whether you or your partner carry variants linked to certain
              inherited conditions. ACOG recommends offering screening for
              cystic fibrosis and spinal muscular atrophy to everyone
              considering pregnancy. FutureFamilyAI offers optional saliva-based
              screening and plain-language summaries reviewed with a genetics
              professional — never a diagnosis on its own. Explore family
              planning tools.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#kulsoom-baloch">
                    Dr. Kulsoom Baloch, MBBS, MPH
                  </Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=member"
              >
                Request Free Pilot Access
              </Link>
              <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Couple discussing carrier screening results with a genetic counselor before pregnancy"
              >
                <figcaption>
                  <b>Photo slot</b> · Couple in their 30s sitting together at a
                  kitchen table with a genetic counselor on a laptop video call;
                  relaxed, engaged expressions. No chromosome graphics or text
                  overlays.
                  <br />
                  <b>Alt:</b> Couple discussing carrier screening results with a
                  genetic counselor before pregnancy
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    ACOG recommends offering carrier screening for cystic
                    fibrosis and spinal muscular atrophy to everyone who is
                    considering pregnancy or is pregnant.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/committee-opinion/articles/2017/03/carrier-screening-for-genetic-conditions">
                        ACOG Committee Opinion No. 691, 2017
                      </a>
                    </cite>
                  </li>
                  <li>
                    About 1 in 25 non-Hispanic white people carry a cystic
                    fibrosis variant; carrier frequency varies by ancestry.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/committee-opinion/articles/2017/03/carrier-screening-for-genetic-conditions">
                        ACOG Committee Opinion No. 691, 2017
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>What carrier screening can — and can&apos;t — tell you</h2>
                <p>
                  A carrier usually has no symptoms. Screening shows whether
                  each partner carries a variant for the same condition, which
                  helps estimate reproductive risk. A negative result lowers,
                  but does not eliminate, risk; no screening guarantees a
                  healthy pregnancy.
                </p>
              </section>
              <section id="s2">
                <h2>Who should consider it</h2>
                <ul>
                  <li>Anyone planning pregnancy, ideally before conceiving.</li>
                  <li>
                    Couples using IVF, donor eggs or a gestational surrogate.
                  </li>
                  <li>People with a family history of a genetic condition.</li>
                  <li>Anyone who wants to understand options early.</li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
              <section id="s3">
                <h2>How the FutureFamilyAI add-on works</h2>
                <ul>
                  <li>Order an at-home saliva kit for each partner.</li>
                  <li>Samples are analyzed by a CLIA-certified laboratory.</li>
                  <li>
                    Results are reviewed by genetics professionals before
                    release.
                  </li>
                  <li>
                    You receive a plain-language couple summary and can book
                    genetic counseling.
                  </li>
                </ul>
              </section>
              <section id="s4">
                <h2>You control the results</h2>
                <p>
                  Your genetic information is never shared by default. You
                  decide whether to share results with your physician, fertility
                  clinic or partner.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      What is carrier screening before pregnancy?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        It is a genetic test, usually on blood or saliva, that
                        checks whether you carry variants for certain inherited
                        conditions. Testing both partners shows whether a future
                        child could be at higher risk.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is carrier screening worth it?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Many families find it valuable because results arrive
                        before decisions are made. ACOG recommends offering
                        certain screening to everyone considering pregnancy. A
                        genetics professional can help you decide.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>When should you do carrier screening?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Ideally before pregnancy, so you have the most options.
                        It can also be done during pregnancy.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Do both partners need carrier screening?</summary>
                    <div className="ffh-ans">
                      <p>
                        Often one partner tests first, and the other tests if a
                        variant is found. Many couples test together to save
                        time. FutureFamilyAI&apos;s couple summary requires
                        results for both partners.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Does insurance cover carrier screening?</summary>
                    <div className="ffh-ans">
                      <p>
                        Coverage varies by plan and indication. Ask your insurer
                        and request a written estimate. The FutureFamilyAI
                        subscription does not include laboratory fees.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Is FutureFamilyAI&apos;s carrier screening a diagnosis?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. It is a screening summary reviewed by genetics
                        professionals. Decisions should be made with a genetic
                        counselor or physician.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                  <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">KB</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Kulsoom Baloch, MBBS, MPH</h3>
                  <p>
                    Clinical Protocol Author, FutureFamilyAI. Dr. Kulsoom
                    Baloch, MBBS, MPH, is the clinical protocol author for
                    FutureFamilyAI and a published researcher in reproductive
                    and maternal health. She developed the app&apos;s monitoring
                    protocol using ACOG, SMFM, ISSHP and AHA guidance.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/family-planning/what-is-carrier-screening">
                    What Is Carrier Screening? →
                  </Link>
                  <Link to="/family-planning/carrier-screening-cost">
                    Carrier Screening Cost →
                  </Link>
                  <Link to="/family-planning/genetic-counseling-before-pregnancy">
                    Genetic Counseling Before Pregnancy →
                  </Link>
                  <Link to="/family-planning/carrier-screening-existing-results">
                    Existing Carrier Screening Results →
                  </Link>
                  <Link to="/family-planning/cystic-fibrosis-carrier-screening">
                    Cystic Fibrosis Carrier Screening →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">
                      What carrier screening can — and can&apos;t — tell you
                    </a>
                  </li>
                  <li>
                    <a href="#s2">Who should consider it</a>
                  </li>
                  <li>
                    <a href="#s3">How the FutureFamilyAI add-on works</a>
                  </li>
                  <li>
                    <a href="#s4">You control the results</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
